import { RouteSubPage } from "shared/route-types";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { AccountProfile } from "components/page/account/profile";
import { AccountProjects } from "components/page/account/projects";
import { NotificationsPage } from "components/page/account/notifications";
import { InformationPage } from "components/page/account/information";
import { useTranslation } from "react-i18next";
import { FavoritesPage } from "components/page/account/personal-favorit-page";

interface Props {
  subPage: RouteSubPage;
}

export const MobileAccountPage = (props: Props) => {
  const { t } = useTranslation();
  const { subPage } = props;
  let selectedSubPage = subPage;

  return (
    <Box sx={{ p: 2 }}>
      {selectedSubPage === "profile" && <AccountProfile />}
      {selectedSubPage === "projects" && <AccountProjects />}
      {selectedSubPage === "favorites" && <FavoritesPage />}
      {selectedSubPage === "notifications" && <NotificationsPage />}
      {selectedSubPage === "information" && <InformationPage />}
    </Box>
  );
};
